var $ = jQuery.noConflict();

$(window).on('load', function () {
    let method = 'front';
    if ($('body').hasClass('wp-admin'))
        method = 'wp-admin';

    var initializeBlock = function ($block) {
        if ($('.block-history-timeline').length > 0) {

            function historyTimelineRender() {
                // Line

                hLine = 0;

                hLine += $('.block-history-timeline__blocks').outerHeight(true);

                hLine -= $('.block-history-timeline__block').not('.empty').last().innerHeight();

                $('.block-history-timeline__line').height(hLine)

                // Animation

                hWindow = $(window).height();
                posBody = $('body').scrollTop();
                posHtml = $('html').scrollTop();

                pos = 0;
                if (posBody > 0)
                    pos = posBody
                if (posHtml > 0)
                    pos = posHtml;

                posLine = ($('.block-history-timeline__line').offset().top - hWindow)
                pp = (pos - posLine) / hWindow;

                heightLine = (pos - posLine) - hWindow / 2;

                $('.block-history-timeline__line div').height(heightLine)

                $('.block-history-timeline__block').removeClass('active');

                $('.block-history-timeline__year').each(function () {
                    let parentBlock = $(this).parents('.block-history-timeline__block');
                    posElement = ($(this).offset().top - hWindow)
                    pp = (pos - posElement) / hWindow;
                    if (pp >= 0.5)
                        parentBlock.addClass('active')
                })

            }

            setTimeout(function () {
                historyTimelineRender();
            }, 100);

            $(window).scroll(function (event) {
                historyTimelineRender();
            });

        }
    };

    window.onload = function () {
        initializeBlock($(this));
    }();

    if (window.acf) {
     window.acf.addAction('render_block_preview/type=history-timeline', initializeBlock);
    }
});
